import { Navigate, Route } from 'react-router-dom';
import Main from './components/layout/main-layout/main';
import {
  APPLICATION_STATUS,
  AVAILABLE_OPENINGS,
  DOCUMENTS_RENEWALS,
  JOIN_OUR_NETWORK,
  QUIZ,
  SIGN_IN,
  SIGN_IN_ADMIN,
  STEPS,
} from './constants/routes.constants';
import ApplicationStatusPage from './pages/application-status/application-status.page';
import ApplicationStepsRoutes from './pages/application-steps/application-steps.routes';
import AvailableOpeningsPage from './pages/available-openings/available-openings.page';
import DocumentsRenewalsForm from './pages/documents-renewals/documents-renewals.page';
import JoinOurNetworkPage from './pages/join-our-network/join-our-network.page';
import QuizPage from './pages/quiz/quiz.page';
import SignInAdmin from './pages/sign-in/sign-in-admin';
import SignInPage from './pages/sign-in/sign-in.page';
import { RedirectTo404 } from './services/sentry/error-boundary';
import SentryRoutes from './services/sentry/sentry-routes';

function MainRoutes() {
  return (
    <SentryRoutes>
      <Route path="/" element={<Main />}>
        <Route path="/" element={<Navigate to={AVAILABLE_OPENINGS} />} />
        <Route path={`/${SIGN_IN}`} element={<SignInPage />} />
        <Route path={`/${SIGN_IN_ADMIN}`} element={<SignInAdmin />} />
        <Route path={`/${JOIN_OUR_NETWORK}`}>
          <Route path=":openingId" element={<JoinOurNetworkPage />} />
        </Route>
        <Route
          path={`/${AVAILABLE_OPENINGS}/*`}
          element={<AvailableOpeningsPage />}
        />
        <Route path={`/${STEPS}/*`} element={<ApplicationStepsRoutes />} />
        <Route
          path={`/${DOCUMENTS_RENEWALS}`}
          element={<DocumentsRenewalsForm />}
        />
        <Route
          path={`/${APPLICATION_STATUS}/:statusKey`}
          element={<ApplicationStatusPage />}
        />
        <Route path={`/${QUIZ}`} element={<QuizPage />} />
        <Route path={'/*'} element={<RedirectTo404 />} />
      </Route>
    </SentryRoutes>
  );
}

export default MainRoutes;
